export function maskAccount(value?: string): string {
  if (!value) return "Not recorded";
  const digits = value.replace(/\D/g, "");
  if (digits.length <= 4) return value.includes("ending") ? value : `ending ${digits}`;
  return `ending ${digits.slice(-4)}`;
}

export function maskTrace(value?: string): string {
  if (!value) return "Not recorded";
  const digits = value.replace(/\D/g, "");
  if (digits.length <= 4) return value;
  return `${value.replace(digits, "")}ending ${digits.slice(-4)}`.trim();
}

export function containsUnmaskedSensitiveNumber(text: string): boolean {
  return /\b\d{9,}\b/.test(text);
}
